import {
  ChangesSide,
  CurrentlyLiveSide,
} from "src/components/CompareChangesModal/types";

/**
 * PLACEHOLDER mock data for the Compare Changes modal.
 *
 * The real published-vs-draft diff is owned by GRWBKK-1651 (shared diff utility)
 * and wired on the Playlist page by GRWBKK-1656. Until those land, the
 * "Compare changes" menu item opens the modal with this static sample so the
 * flow is demoable. Replace `getCompareChangesMockData` with the computed diff
 * once the diff utility is available.
 */

export interface CompareChangesMock {
  currentlyLive: CurrentlyLiveSide;
  changes: ChangesSide;
}

export const getCompareChangesMockData = (): CompareChangesMock => ({
  currentlyLive: {
    publishedAt: "2022-02-02T09:41:00.000Z",
    items: [
      {
        id: "live-1",
        position: 1,
        title: "Bangkok Messages",
        subtitle: "App",
        durationLabel: "00:00:25",
      },
      {
        id: "live-2",
        position: 2,
        title: "SC - General",
        subtitle: "App",
        durationLabel: "00:00:25",
      },
      {
        id: "live-3",
        position: 3,
        title: "Stocks Market - Tech (BKK)",
        subtitle: "App",
        durationLabel: "00:00:25",
      },
      {
        id: "live-4",
        position: 4,
        title: "Sahara",
        subtitle: "Media",
        durationLabel: "00:00:25",
      },
      {
        id: "live-5",
        position: 5,
        title: "Live Bug Tracker",
        subtitle: "App",
        durationLabel: "00:00:25",
      },
      {
        id: "live-6",
        position: 6,
        title: "Bangkok 2026",
        subtitle: "Media",
        durationLabel: "00:00:25",
      },
      {
        id: "live-7",
        position: 7,
        title: "Bangkok Trip",
        subtitle: "Media",
        durationLabel: "00:00:25",
      },
    ],
  },
  changes: {
    totalChanges: 4,
    publishedAt: "2022-02-02T09:41:00.000Z",
    lastEditedBy: { name: "Richard Parker" },
    items: [
      {
        id: "chg-1",
        position: 1,
        title: "Bangkok Messages",
        subtitle: "App",
        changeType: "removed",
      },
      {
        id: "chg-2",
        position: 2,
        title: "SC - General",
        subtitle: "App",
        changeType: "unchanged",
        durationLabel: "00:00:25",
      },
      {
        id: "chg-3",
        position: 3,
        title: "Stocks Market - Tech (BKK)",
        subtitle: "App",
        changeType: "edited",
        durationLabel: "00:00:45",
      },
      {
        id: "chg-4",
        position: 4,
        title: "Sahara",
        subtitle: "Media",
        changeType: "unchanged",
        durationLabel: "00:00:25",
      },
      {
        id: "chg-5",
        position: 5,
        title: "Bangkok 2026",
        subtitle: "Media",
        changeType: "unchanged",
        durationLabel: "00:00:25",
      },
      {
        id: "chg-6",
        position: 6,
        title: "Live Bug Tracker",
        subtitle: "App",
        changeType: "reordered",
        actor: { name: "Richard Parker" },
      },
      {
        id: "chg-7",
        position: 7,
        title: "Bangkok Trip",
        subtitle: "Media",
        changeType: "unchanged",
        durationLabel: "00:00:25",
      },
      {
        id: "chg-8",
        position: 8,
        title: "BKK Weather",
        subtitle: "Travel",
        changeType: "added",
        actor: { name: "Richard Parker" },
      },
    ],
  },
});
